import { render } from "./SelectionMenuStep5.vue?vue&type=template&id=13f64c2b&scoped=true"
import script from "./SelectionMenuStep5.vue?vue&type=script&lang=ts"
export * from "./SelectionMenuStep5.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-13f64c2b"

export default script